import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import InactiveIngredientService from '../../services/inactiveIngredientService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InactiveIngredientFilterSettingsModel, InactiveIngredientGridModel, InactiveIngredientForGridModel }
  from "../../models/inactiveIngredient";

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any
}

interface IState {
  isLoading: boolean;
  error: any;
  inactiveIngredients: Array<InactiveIngredientForGridModel>
  selectedInactiveIngredients: Array<InactiveIngredientForGridModel>;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  inactiveIngredientSettings: InactiveIngredientFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class InactiveIngredientListDialog extends React.Component<IProps, IState> {

  inactiveIngredientService = new InactiveIngredientService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      inactiveIngredients: new Array<InactiveIngredientForGridModel>(),
      selectedInactiveIngredients: new Array<InactiveIngredientForGridModel>(),
      inactiveIngredientSettings: new InactiveIngredientFilterSettingsModel()
    }
  }

  componentDidMount() {
    this.getAllInactiveIngredients(this.state.from, this.state.numberOfRows);
  }

  getAllInactiveIngredients(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.inactiveIngredientService.getAllInactiveIngredients(from, numberOfRows, this.state.inactiveIngredientSettings).then(
      (data: InactiveIngredientGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          inactiveIngredients: data.inactiveIngredients,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllInactiveIngredients(startIndex, this.state.numberOfRows);
  }

  handleOkButton = event => {
    event.preventDefault();

    const selectedInactiveIngredients = this.state.selectedInactiveIngredients;

    this.props.okClick(selectedInactiveIngredients);
  }

  handleCanselButton = () => {
    this.props.cancelClick();
  }

  render() {
    return (
      <Dialog header="Active Ingredients" responsive={true} width="60%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCanselButton}
        footer={
          <div>
            <Button label="Add" icon="pi pi-check" onClick={this.handleOkButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '400px', maxHeight: '550px', overflowY: 'auto' }}>
          <DataTable value={this.state.inactiveIngredients}
            paginator={true}
            lazy={true}
            rows={this.state.numberOfRows}
            first={this.state.from}
            selection={this.state.selectedInactiveIngredients}
            totalRecords={this.state.totalRecordsCount}
            onPage={(event) => this.handleOnPageClick(event)}
            onSelectionChange={(e) => this.setState({ selectedInactiveIngredients: e.data })}>
            <Column selectionMode="multiple" style={{ width: '3em' }} />
            <Column header="Name"
              body={(rowData, column) =>
                rowData && rowData.inactiveIngredientContent && rowData.inactiveIngredientContent.length ?
                  rowData.inactiveIngredientContent
                    .filter(x => typeof x.name === 'string' && x.name.length > 0)
                    .map(r => r.name)
                    .join(' / ')
                  : null
              } />
          </DataTable>
        </div>
      </Dialog>
    )
  }

}

export default InactiveIngredientListDialog;